import { render } from "./TrendingCard.vue?vue&type=template&id=3f4bd92f&scoped=true"
import script from "./TrendingCard.vue?vue&type=script&lang=js"
export * from "./TrendingCard.vue?vue&type=script&lang=js"

import "./TrendingCard.vue?vue&type=style&index=0&id=3f4bd92f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4bd92f"]])

export default __exports__